import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaret = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 8L0.803847 0.5L11.1962 0.500001L6 8Z",
		fill: "#282828"
	})
});
export default SvgCaret;
